// extracted by mini-css-extract-plugin
export default {"tit":"index_tit_4GGJf"};